import { thousand } from '../../../utils/format';

export const getChartOptions = (label = '', unit = '') => ({
  responsive: true,
  legend: false,
  scales: {
    xAxes: [
      {
        offset: true,
        gridLines: false,
        ticks: {
          maxRotation: 45,
          minRotation: 45,
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
          labelString: label,
          padding: { bottom: 20 },
        },
        offset: true,
        gridLines: { drawBorder: false },
        ticks: { beginAtZero: true },
      },
    ],
  },
  tooltips: {
    displayColors: false,
    titleMarginBottom: 5,
    backgroundColor: '#fff',
    position: 'average',
    titleFontColor: '#666',
    bodyFontColor: '#666',
    borderColor: '#ededed',
    borderWidth: 1,
    callbacks: {
      title: function (tooltipItems) {
        return thousand(tooltipItems[0].value) + ' ' + unit;
      },
      label: function (tooltipItem) {
        return tooltipItem.xLabel.join(' ');
      },
    },
    titleFontSize: 15,
    xPadding: 15,
    yPadding: 10,
    titleAlign: 'center',
    bodyAlign: 'center',
  },
});
